import React from 'react';
import { useFlightSelection } from '@/hooks/useFlightSelection';

export const withFlightSelection = (Component) => (props) => {
  const flightSelectionProps = useFlightSelection(window.location.href);

  if (flightSelectionProps === null) {
    return null;
  }

  return <Component {...props} {...flightSelectionProps} />;
};
